import clsx from "classnames";
import PastEventCard from "@/ui/PastEventCard";
import { Heading } from "@/ui/Heading";
import { DynamicText } from "@/ui/DynamicText";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { useLocale } from "@/hooks/useLocale";
import { events_helper } from "@/helpers/events_helper";

export const EventsPagePastEventsSection = ({ className, events, loading }) => {
  const locale = useLocale();

  return (
    <div className={clsx(className)}>
      <Container className="mb-md-5">
        <Heading className="mb-4">
          <DynamicText path={`page.events.section.past.title.${locale}`} tag="h2" />
        </Heading>
        <Row>
          {loading ? (
            <div className="d-flex justify-content-center align-items-center p-5">
              <Spinner variant="primary" />
            </div>
          ) : (
            events.map((i) => (
              <Col key={i.id} xs={12} sm={6} md={4} lg={3} xl={6} className="mb-4">
                <PastEventCard item={i} />
              </Col>
            ))
          )}
        </Row>
      </Container>
    </div>
  );
};
